<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-md-8 col-lg-7 mx-auto">
        <div class="card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
              <vue-feather type="bar-chart-2" class="me-1"></vue-feather> Nueva métrica
              <span v-if="nombrePrograma" class="badge bg-primary ms-2 fw-normal fs-6">{{ nombrePrograma }}</span>
            </h5>
            <button class="btn btn-outline-secondary btn-sm" @click="$router.back()">
              <vue-feather type="arrow-left" size="14" class="me-1"></vue-feather> Regresar
            </button>
          </div>

          <div class="card-body">

            <div v-if="successMsg" class="alert alert-success d-flex align-items-center">
              <vue-feather type="check-circle" size="16" class="me-2"></vue-feather> {{ successMsg }}
            </div>
            <div v-if="errorMsg" class="alert alert-danger d-flex align-items-center">
              <vue-feather type="alert-circle" size="16" class="me-2"></vue-feather> {{ errorMsg }}
            </div>

            <form @submit.prevent="guardar" novalidate>
              <div class="row g-3">

                <div class="col-12">
                  <label class="form-label">Nombre de la métrica <span class="text-danger">*</span></label>
                  <input
                    v-model="form.nombre_metrica"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.nombre_metrica }"
                    placeholder="Ej. Créditos rechazados"
                  />
                  <div class="invalid-feedback">Campo requerido.</div>
                </div>

                <div class="col-12">
                  <label class="form-label">Definición</label>
                  <textarea
                    v-model="form.definicion"
                    class="form-control"
                    rows="2"
                    placeholder="Descripción de la métrica"
                  ></textarea>
                </div>

                <div class="col-12">
                  <label class="form-label">Fórmula</label>
                  <input
                    v-model="form.formula"
                    type="text"
                    class="form-control"
                    placeholder="Ej. suma(créditos rechazados)"
                  />
                </div>

                <div class="col-md-6">
                  <label class="form-label">Unidad de medida <span class="text-danger">*</span></label>
                  <select
                    v-model="form.unidad_medida"
                    class="form-select"
                    :class="{ 'is-invalid': errors.unidad_medida }"
                  >
                    <option value="" disabled>Selecciona</option>
                    <option value="MONETARIO">Monetaria</option>
                    <option value="ABSOLUTO">Absoluto</option>
                    <option value="PORCENTAJE">Porcentaje</option>
                    <option value="TASA">Tasa</option>
                    <option value="INDICE">Índice</option>
                  </select>
                  <div class="invalid-feedback">Campo requerido.</div>
                </div>

                <div class="col-md-6">
                  <label class="form-label">Periodicidad <span class="text-danger">*</span></label>
                  <select
                    v-model="form.periodicidad"
                    class="form-select"
                    :class="{ 'is-invalid': errors.periodicidad }"
                  >
                    <option value="" disabled>Selecciona</option>
                    <option value="MENSUAL">Mensual</option>
                    <option value="TRIMESTRAL">Trimestral</option>
                    <option value="SEMESTRAL">Semestral</option>
                    <option value="ANUAL">Anual</option>
                  </select>
                  <div class="invalid-feedback">Campo requerido.</div>
                </div>

                <div class="col-md-6">
                  <label class="form-label">Línea base</label>
                  <div v-if="form.unidad_medida === 'MONETARIO'" class="input-group">
                    <span class="input-group-text">$</span>
                    <input v-model.number="form.linea_base" type="number" class="form-control" placeholder="0" />
                  </div>
                  <input v-else v-model.number="form.linea_base" type="number" class="form-control" placeholder="0" />
                </div>

                <div class="col-md-6">
                  <label class="form-label">Meta final</label>
                  <div v-if="form.unidad_medida === 'MONETARIO'" class="input-group">
                    <span class="input-group-text">$</span>
                    <input v-model.number="form.meta_final" type="number" class="form-control" placeholder="0" />
                  </div>
                  <input v-else v-model.number="form.meta_final" type="number" class="form-control" placeholder="0" />
                </div>

              </div>

              <div class="d-flex justify-content-end gap-2 mt-4">
                <button type="button" class="btn btn-outline-secondary" @click="$router.back()">Cancelar</button>
                <button type="submit" class="btn btn-success" :disabled="guardando">
                  <span v-if="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span> Guardando…
                  </span>
                  <span v-else>
                    <vue-feather type="save" size="14" class="me-1"></vue-feather> Guardar métrica
                  </span>
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/axios";

export default {
  name: "NuevaMetrica",

  data() {
    return {
      programaId: null,
      nombrePrograma: null,
      form: {
        nombre_metrica: "",
        definicion: "",
        formula: "",
        unidad_medida: "",
        periodicidad: "",
        linea_base: 0,
        meta_final: 0,
      },
      errors: {},
      guardando: false,
      successMsg: null,
      errorMsg: null,
    };
  },

  created() {
    this.programaId = Number(this.$route.params.programaId);
    this.nombrePrograma = this.$route.query.nombre ?? null;
  },

  methods: {
    validar() {
      const e = {};
      if (!this.form.nombre_metrica.trim()) e.nombre_metrica = true;
      if (!this.form.unidad_medida) e.unidad_medida = true;
      if (!this.form.periodicidad) e.periodicidad = true;
      this.errors = e;
      return Object.keys(e).length === 0;
    },

    async guardar() {
      if (!this.validar()) return;
      this.guardando = true;
      this.successMsg = null;
      this.errorMsg = null;
      try {
        const payload = { ...this.form, programa: this.programaId };
        const { data } = await api.post("metricas-config/", payload);
        this.successMsg = `Métrica "${data.nombre_metrica}" registrada correctamente.`;
        this.form = {
          nombre_metrica: "", definicion: "", formula: "",
          unidad_medida: "", periodicidad: "", linea_base: 0, meta_final: 0,
        };
        this.errors = {};
        setTimeout(() => this.$router.back(), 1500);
      } catch (err) {
        this.errorMsg =
          err.response?.data?.detail ??
          JSON.stringify(err.response?.data) ??
          "Error al guardar la métrica.";
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>
